export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.119 2.224a1 1 0 011.338.068l6.75 6.75a1 1 0 010 1.415l-1.168 1.167 5.71 5.711.75-.75 2.915 2.915-2.914 2.914-2.914-2.915.75-.75-5.711-5.71-1.168 1.168a1 1 0 01-1.414 0l-6.75-6.75a1 1 0 010-1.415l3.75-3.75.076-.068zM4.414 6.75l5.336 5.335 2.336-2.335L6.75 4.414 4.414 6.75z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};